import RegDataProvider from 'global/cnr/contexts/RegDataContext';
import AppUsersProvider from '../cnr/contexts/AppUsersContext';
import DataWrapperProvider from '../cnr/contexts/DataWrapperContext';
import ManifestProvider from '../cnr/contexts/ManifestContext';
import PapsProvider from '../cnr/contexts/PapsContext';
import SearchParamProvider from '../cnr/contexts/SearchParamContext';
import ServiceWorkerProvider from '../cnr/contexts/ServiceWorkerContext';
import SettingsDataProvider from '../cnr/contexts/SettingsDataContext';
import AppView from './AppView';
import { ManifestWatcher } from 'ManifestWatcher';
import AppTimestampProvider from 'global/cnr/contexts/AppTimestampContext';


/** Starting point fo the Page
@componentContexts [StartContext, AuthContext, AppSettingContext]  
*/
function AppRoutes() {
  // return <div style={{ color: 'white' }}>AppRoutes</div>
  return (
    <SearchParamProvider>
      <PapsProvider>
        <AppTimestampProvider>
          <RegDataProvider>
            <SettingsDataProvider>
              <ManifestProvider>
                <ServiceWorkerProvider>
                  <AppUsersProvider>
                    <DataWrapperProvider>
                      <ManifestWatcher />
                      <AppView />
                    </DataWrapperProvider>
                  </AppUsersProvider>
                </ServiceWorkerProvider>
              </ManifestProvider>
            </SettingsDataProvider>
          </RegDataProvider>
        </AppTimestampProvider>
      </PapsProvider >
    </SearchParamProvider>
  )
}

export default AppRoutes